
const TabNavigation: React.FC<{
  activeTab: string;
  setActiveTab: (tab: 'register' | 'skills' | 'dashboard' | 'cv' | 'admin') => void;
}> = ({ activeTab, setActiveTab }) => {
  const tabs = [
    { id: 'register' as const, label: '📝 Register', icon: 'ri-user-add-line' },
    { id: 'skills' as const, label: '🎯 Choose Skills', icon: 'ri-book-mark-line' },
    { id: 'dashboard' as const, label: '📊 Dashboard', icon: 'ri-dashboard-3-line' },
    { id: 'cv' as const, label: '📄 CV Assistant', icon: 'ri-file-list-3-line' },
    { id: 'admin' as const, label: '👨‍💼 Admin View', icon: 'ri-admin-line' },
  ];

  return (
    <div className="flex flex-wrap justify-center gap-3">
      {tabs.map(tab => (
        <button
          key={tab.id}
          onClick={() => setActiveTab(tab.id)}
          className={`flex items-center gap-2 px-6 py-3 rounded-xl font-semibold transition-all duration-300 ${
            activeTab === tab.id
              ? 'bg-gradient-to-r from-blue-600 to-red-600 text-white shadow-lg scale-105'
              : 'bg-gray-100 text-gray-600 hover:bg-gray-200 hover:shadow-md'
          }`}
        >
          <i className={`${tab.icon} text-lg`}></i>
          <span className="text-sm md:text-base">{tab.label}</span>
        </button>
      ))}
    </div>
  );
};

export default TabNavigation;
